import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import SignUp from "./components/auth/signUp";
import ForgotPasscode from "./components/auth/forgotPasscode";
import SignIn from "./components/auth/signIn";
import TypeSelectionPage from "./components/typeSelection/typeSelection";
import GlobalModal from "./components/shared/modals/globalModal";
import PortalSelector from "./components/portalSelector/portalSelector";
import EmailGuard from "./components/shared/EmailGuard";
import ResetPassword from "./components/auth/ResetPassword";
import NotFound from "./components/shared/NotFound";
import MicrosoftCallback from "./components/auth/MicrosoftCallback";
import TermsAndConditions from "./components/legal/TermsPage";
import EmailVerificationExpired from "./components/auth/EmailVerificationExpired";

const HOST_CANONICAL_ORIGINS = {
  "polite-sky-0bfe59e0f.6.azurestaticapps.net":
    "https://talent-dev.mayamaya.ai",
  "black-ground-051210b0f.6.azurestaticapps.net":
    "https://talent-test.mayamaya.ai",
};

function ensureOrigin(origin) {
  return String(origin || "").replace(/\/+$/, "");
}

export function redirectToCanonicalDomain() {
  if (typeof window === "undefined") return false;

  const host = window.location.hostname.toLowerCase();
  const canonical = HOST_CANONICAL_ORIGINS[host];

  // If current host is not one of the Azure domains we care about, do nothing
  if (!canonical) return false;

  const canonicalOrigin = ensureOrigin(canonical);
  const currentOrigin = ensureOrigin(window.location.origin);

  // Avoid loops
  if (currentOrigin === canonicalOrigin) return false;

  const next =
    canonicalOrigin +
    window.location.pathname +
    window.location.search +
    window.location.hash;

  window.location.replace(next);
  return true;
}

const CanonicalDomainRedirect = () => {
  useEffect(() => {
    redirectToCanonicalDomain();
  }, []);
  return null;
};

const AppRoutes = () => (
  <>
    <CanonicalDomainRedirect />

    <Routes>
      <Route path="/" element={<Navigate to="/signin" replace />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPasscode />} />
      <Route path="/auth/google/callback" element={<SignUp />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/microsoft/callback" element={<MicrosoftCallback />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/verify-email" element={<EmailVerificationExpired />} />

      <Route
        path="/type-selection"
        element={
          <EmailGuard>
            <TypeSelectionPage />
          </EmailGuard>
        }
      />
      <Route
        path="/portal-selector"
        element={
          <EmailGuard>
            <PortalSelector />
          </EmailGuard>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Routes>

    <GlobalModal />
  </>
);

export default AppRoutes;
